import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';
import { appConfig, validateConfig } from './config/appConfig';

// Validate configuration before starting the app
try {
  validateConfig();
} catch (error) {
  console.error('Configuration validation failed:', error.message);
  document.body.innerHTML = `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; font-family: Inter, sans-serif; text-align: center; padding: 20px;">
      <h1 style="color: #dc3545; margin-bottom: 20px;">Configuration Error</h1>
      <p style="color: #6c757d; margin-bottom: 20px;">${error.message}</p>
      <p style="color: #6c757d; font-size: 14px;">Please check your environment variables and try again.</p>
    </div>
  `;
  throw error;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={appConfig.auth0.domain}
      clientId={appConfig.auth0.clientId}
      authorizationParams={{
        redirect_uri: appConfig.auth0.redirectUri
      }}
      onRedirectCallback={appState => {
        window.history.replaceState({}, document.title, "/");
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
); 